// app/javascript/controllers/reveal_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    // console.log("RevealController connected!");
  }

  showColumn(event) {
    // Get the table ID from the button's data attribute
    // const tableId = event.target.dataset.tableId;

    // Find the table and toggle the visibility of hidden elements
    // const table = document.getElementById("athletes-table");
    // if (table) {
    //   table.querySelectorAll(".action-item").forEach((column) => {
    //     column.classList.toggle("d-none");
    //     column.classList.toggle("visible"); // Use the "visible" class to trigger the transition
    //   });
    // }
    const table = document.getElementById("athletes-table");
    if (table) {
      table.querySelectorAll(".action-item").forEach((column) => {
        column.classList.toggle("d-none");
      });
    }

    // Update button text to indicate the current state
    const button = event.target;
    if (button.textContent.trim() === "Archive") {
      button.textContent = "Dismiss";
    } else {
      button.textContent = "Archive";
    }
  }

}
